export class ArgumentNullError extends Error {
    constructor(paramName: string, paramValue: any) {
        super(`${paramName} has null value: ${paramValue}`);
        this.name = 'ArgumentNullError';
    }
}
